export default __webpack_public_path__ + "static/media/ic_rider.4c110737.svg";